import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  CreditCardOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  RedoOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Dropdown, Layout, Space, Tooltip } from "antd";
import {
  BagIcon,
  NoticeboardIcon,
  RepeatIcon,
  SettingIcon,
  ShareIcon,
  SubcriptionIcon,
  UserIcon,
  WorkSpaceIcon,
} from "assets/icons";
import { signOut } from "firebase/auth";
import SwitchWorkspace from "pages/admin/switchWorkspace";
import UserUpdatePasswordForm from "pages/admin/updatePassword";
import { AuthInfo, getMe, logout } from "stores/slices/auth";
import {
  getHeaderTitle,
  getSubHeaderTitle,
  setIsRefreshDashboard,
} from "stores/slices/layout";
import { resetNotificationCount } from "stores/slices/notification";
import { doGetUserInfo, getUserDetail } from "stores/slices/user";
import { setWorkspace } from "stores/slices/workspace";
import { auth } from "useFirebase/firebase";
import { USER_ROLES } from "utils/editorConfig";

import { USER_TYPE, WORKSPACE_USER_TYPE } from "../constants/appConstant";

import ModalForm from "./forms/components/modalForm";
import Notification from "./notification/Notification";
import MessageOfTheDay from "./MessageOfTheDay";

import "../assets/styles/dropDownStyle.scss";
import styles from "./styles.module.scss";

const Header = props => {
  const { collapsed, setCollapsed, broken, currentMenu } = props;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { t } = useTranslation();

  const authInfo = useSelector(AuthInfo);

  const userInfo = useSelector(getUserDetail);
  const [isOpenUpdatePassword, setIsOpenUpdatePassword] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isOpenPolicy, setIsOpenPolicy] = useState(false);
  const [isTermsOfService, setIsTermsOfService] = useState(false);
  const [isVisbleModal, setisVisbleModal] = useState(false);
  const [inputText, setInputText] = useState("");
  const [isUpdateDailyMessage, setIsUpdateDailyMessage] = useState(false);
  const headerTitle = useSelector(getHeaderTitle);
  const subHeaderTitle = useSelector(getSubHeaderTitle);

  const items = [
    {
      key: "user-menu",
      type: "group",
      label: "User",
      children: [
        {
          key: "user-profile",
          label: t("label.userDetails"),
          icon: <UserIcon />,
          onClick: () => {
            navigate("/admin/user-profile");
          },
        },
        {
          key: "update-password",
          label: t("label.updatePassword"),
          icon: <RepeatIcon />,
          onClick: () => {
            setIsOpenUpdatePassword(true);
          },
          disabled: authInfo.snsAccount,
        },
        {
          key: "logout",
          label: t("label.logout"),
          icon: <ShareIcon />,
          onClick: () => {
            dispatch(logout());
            // Delete facebook permissions
            if (window.FB) {
              window.FB.api("/me/permissions", "delete", null, () =>
                window.FB.logout()
              );
            }
            signOut(auth)
              .then(() => {
                console.log("Sign-out successful");
                // Sign-out successful.
              })
              .catch(error => {
                console.log(error);
                // An error happened.
              });
            dispatch(setWorkspace(null));
            dispatch(resetNotificationCount());
          },
        },
      ],
    },
    {
      key: "workspace-menu",
      type: "group",
      label: "Workspace",
      children: [
        {
          key: "workspace-profile",
          label: t("label.workspaceProfile"),
          icon: <WorkSpaceIcon />,
          onClick: () => {
            navigate("/admin/workspace-profile");
          },
          disabled:
            (authInfo.type === USER_TYPE.USER &&
              (!authInfo.workspaceRole ||
                authInfo.workspaceRole !== WORKSPACE_USER_TYPE.ADMIN)) ||
            authInfo.type === USER_TYPE.SUPER_ADMIN,
        },
        {
          key: "subscriptions",
          label: t("label.subscription"),
          icon: <SubcriptionIcon />,
          onClick: () => {
            navigate("/admin/subscriptions");
          },
          disabled:
            authInfo.type === USER_TYPE.USER &&
            (!authInfo.workspaceRole ||
              authInfo.workspaceRole !== WORKSPACE_USER_TYPE.ADMIN),
        },
        {
          key: "notice",
          label: t("label.noticeboard"),
          icon: <NoticeboardIcon />,
          onClick: () => {
            navigate("/admin/notice");
          },
          disabled:
            !authInfo.workspaceId || authInfo.type === USER_TYPE.SUPER_ADMIN,
        },
        {
          key: "setting",
          label: t("label.setting"),
          icon: <SettingIcon />,
          onClick: () => {
            navigate("/admin/setting");
          },
          disabled:
            !authInfo.workspaceId || authInfo.type === USER_TYPE.SUPER_ADMIN,
        },
        {
          key: "manage-card",
          label: t("workspace.manageCard"),
          icon: (
            <CreditCardOutlined
              className={styles.creditCustom}
              style={{ marginInlineEnd: 0 }}
            />
          ),
          onClick: () => {
            navigate(`/admin/workspaces/${authInfo.workspaceId}/card`);
          },
          disabled:
            authInfo.workspaceRole === USER_ROLES.OPERATOR ||
            authInfo.type === USER_TYPE.SUPER_ADMIN,
        },
        // {
        //   key: "switch-workspace",
        //   label: t("label.switchWorkspace"),
        //   icon: (
        //     <BagIcon
        //       className={styles.creditCustom}
        //       style={{ marginInlineEnd: 0 }}
        //     />
        //   ),
        //   onClick: () => {
        //     navigate(`/admin/workspaces/${authInfo.workspaceId}/card`);
        //   },
        //   disabled:
        //     !authInfo.workspaceId || authInfo.type === USER_TYPE.SUPER_ADMIN,
        //   children: [
        //     {
        //       key: "switch-workspace-sub",
        //       label: "check",
        //     },
        //   ],
        // },
        {
          key: "switch-workspace",
          className: styles.switchWorkspace,
          label: t("label.switchWorkspace"),
          icon: <BagIcon />,
          disabled:
            !authInfo.workspaceId || authInfo.type === USER_TYPE.SUPER_ADMIN,
          children: [
            {
              key: "switch-workspace-sub",
              className: "switchWorkspaceSub",
              label: (
                <>
                  <SwitchWorkspace />
                </>
              ),
            },
          ],
        },
        {
          key: "privacy-policy",
          label: "Privacy Policy",
          onClick: () => {
            setIsOpenPolicy(true);
          },
        },
        {
          key: "terms-of-service",
          label: "Terms of Service",
          onClick: () => {
            setIsTermsOfService(true);
          },
        },
        {
          key: "support",
          label: "Support",
          onClick: () => {
            window.open("https://wa.me/61488223223", "_blank");
          },
        },
      ],
    },
  ];

  useEffect(() => {
    if (authInfo.id && !isFirstLoad) {
      dispatch(doGetUserInfo(authInfo.id));
    }
  }, [authInfo]);

  useEffect(() => {
    getAuthInfoFirst().then(async res => {
      if (res) {
        setIsFirstLoad(false);
        await dispatch(doGetUserInfo(authInfo.id));
      }
    });
  }, []);

  const getAuthInfoFirst = async () => {
    const { payload } = await dispatch(getMe());
    return payload;
  };

  return (
    <>
      <Layout.Header className={styles.headerContent}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          {broken && (
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "15px",
              }}
            />
          )}
          {typeof headerTitle === "string" && (
            <h2 style={{ marginBottom: 0, fontWeight: 500 }}>
              {t(`title.${headerTitle}`)}
            </h2>
          )}
          {typeof headerTitle === "object" && (
            <>
              {headerTitle.map((item, index) => (
                <h2 style={{ marginBottom: 0 }} key={index}>
                  <span style={{ fontWeight: index === 0 ? 500 : "bold" }}>
                    {t(`title.${item}`)}
                  </span>
                  {index < headerTitle.length - 1 && (
                    <span style={{ margin: "0 8px" }}>|</span>
                  )}
                </h2>
              ))}
            </>
          )}
          {((window.location.pathname.includes("customer") &&
            window.location.pathname.split("/")[4] !== "all") ||
            (window.location.pathname.includes("setting") &&
              window.location.pathname.split("/")[3]) ||
            (window.location.pathname.includes("subscription") &&
              window.location.pathname.split("/")[3]) ||
            (window.location.pathname.includes("notice") &&
              window.location.pathname.split("/")[3])) &&
            subHeaderTitle && (
              <>
                <span style={{ margin: "0 8px" }}>-</span>
                <div
                  style={{
                    width: "400px",
                  }}
                >
                  <Tooltip title={subHeaderTitle}>
                    <h2
                      style={{
                        marginBottom: 0,
                        fontWeight: 500,
                        height: "65px",
                        width: 700,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {subHeaderTitle}
                    </h2>
                  </Tooltip>
                </div>
              </>
            )}
        </div>

        <div className={styles.headerWrap}>
          {headerTitle === "dashboard" && (
            <Tooltip title={t("button.refresh")}>
              <Button
                type="text"
                shape="circle"
                onClick={() => {
                  dispatch(setIsRefreshDashboard(true));
                }}
                // disabled={isLoading}
              >
                <RedoOutlined />
              </Button>
            </Tooltip>
          )}
          <Notification
            userId={authInfo?.id}
            timezone={userInfo?.timeZone}
            role={authInfo?.workspaceRole}
            userType={authInfo?.type}
          />
          <Dropdown
            menu={{
              items,
              selectable: true,
              selectedKeys: [currentMenu],
            }}
            destroyPopupOnHide={true}
            trigger="click"
            placement="bottomRight"
            overlayClassName="headerDropdown"
            dropdownRender={menu => (
              <div className={styles.userHeaderDropdown}>
                <Space
                  style={{
                    width: 350,
                    background: "#DCE1FF",
                    padding: 24,
                    borderTopLeftRadius: 8,
                    borderTopRightRadius: 8,
                  }}
                >
                  <Avatar
                    className={styles.headerIcon}
                    icon={<UserOutlined />}
                    size={{ xs: 24, sm: 32, md: 40, lg: 54, xl: 54, xxl: 54 }}
                  />
                  <div>
                    <Tooltip
                      title={
                        userInfo?.firstName || userInfo?.lastName
                          ? userInfo?.firstName + " " + userInfo?.lastName
                          : userInfo?.email
                      }
                    >
                      <h3
                        style={{
                          marginBottom: 0,
                          fontWeight: 700,
                          color: "#101828",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: 200,
                        }}
                      >
                        {userInfo?.firstName || userInfo?.lastName
                          ? userInfo?.firstName + " " + userInfo?.lastName
                          : userInfo?.email}
                      </h3>
                    </Tooltip>
                    <Tooltip title={authInfo?.workspaceName} placement="bottom">
                      <h4
                        style={{
                          marginBottom: 0,
                          // fontWeight: 700,
                          // color: "#101828",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          width: 200,
                        }}
                      >
                        {authInfo?.workspaceName}
                      </h4>
                    </Tooltip>
                  </div>
                </Space>
                {React.cloneElement(menu)}
              </div>
            )}
          >
            <Avatar
              className={styles.headerIcon}
              icon={<UserOutlined />}
              style={{ cursor: "pointer" }}
              onClick={e => e.preventDefault()}
            />
          </Dropdown>
        </div>
      </Layout.Header>
      {headerTitle === "dashboard" && (
        <MessageOfTheDay
          isVisbleModal={isVisbleModal}
          setisVisbleModal={setisVisbleModal}
          inputText={inputText}
          setInputText={setInputText}
          setIsUpdateDailyMessage={setIsUpdateDailyMessage}
          isUpdateDailyMessage={isUpdateDailyMessage}
          isShowDailyMessage={true}
        />
      )}
      <ModalForm
        title={t("title.updatePassword")}
        onCancel={() => setIsOpenUpdatePassword(false)}
        onSubmit={() => setIsOpenUpdatePassword(false)}
        destroyOnClose={true}
        isOpen={isOpenUpdatePassword}
        labelSubmit={t("label.save")}
        customWidth={700}
        footer={false}
        maskClosable={false}
      >
        <UserUpdatePasswordForm
          onCancel={() => setIsOpenUpdatePassword(false)}
        />
      </ModalForm>
      <ModalForm
        onCancel={() => setIsOpenPolicy(false)}
        destroyOnClose={true}
        isOpen={isOpenPolicy}
        customWidth={1000}
        footer={false}
        maskClosable={false}
      >
        <div
          style={{
            marginTop: 20,
          }}
        >
          <iframe
            src="https://messageclub.com/privacy-policy.html"
            width="100%"
            height="600px"
            title="Privacy Policy"
          ></iframe>
        </div>
      </ModalForm>
      <ModalForm
        onCancel={() => setIsTermsOfService(false)}
        destroyOnClose={true}
        isOpen={isTermsOfService}
        customWidth={1000}
        footer={false}
        maskClosable={false}
      >
        <div
          style={{
            marginTop: 20,
          }}
        >
          <iframe
            src="https://messageclub.com/term-of-service.html"
            width="100%"
            height="600px"
            title="Terms of Service"
          ></iframe>
        </div>
      </ModalForm>
    </>
  );
};

export default Header;
